import { memo, PropsWithChildren } from 'react'

import { PermissionsProps } from './types'
import usePermissions from 'features/auth/permissions/usePermissions'

function Permissions({
  allow,
  children,
  domainId,
}: PropsWithChildren<PermissionsProps>) {
  const [grantAccess] = usePermissions({ allow, domainId })

  return grantAccess ? <>{children}</> : null
}

export default memo(Permissions)
